import { Card } from "@/components/ui/card";
import { Building, AlertTriangle, School } from "lucide-react";
import type { NeighborhoodStats } from "@/integrations/supabase/types/tables/realEstate";

interface PropertyNeighborhoodProps {
  neighborhoodStats: NeighborhoodStats | null;
}

export const PropertyNeighborhood = ({ neighborhoodStats }: PropertyNeighborhoodProps) => {
  if (!neighborhoodStats) return null;

  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">Neighborhood Statistics</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {neighborhoodStats.population && (
          <div className="flex items-start space-x-3">
            <Building className="h-5 w-5 text-primary mt-1" />
            <div>
              <h3 className="font-medium">Population</h3>
              <p className="text-muted-foreground">
                {neighborhoodStats.population.toLocaleString()}
              </p>
            </div>
          </div>
        )}
        {neighborhoodStats.crime_rate && (
          <div className="flex items-start space-x-3">
            <AlertTriangle className="h-5 w-5 text-primary mt-1" />
            <div>
              <h3 className="font-medium">Crime Rate</h3>
              <p className="text-muted-foreground">
                {neighborhoodStats.crime_rate}%
              </p>
            </div>
          </div>
        )}
      </div>
      {neighborhoodStats.schools?.length > 0 && (
        <div className="mt-6">
          <h3 className="font-medium mb-3">Nearby Schools</h3>
          <ul className="space-y-3">
            {neighborhoodStats.schools.map((school, index) => (
              <li key={index} className="flex items-start space-x-3">
                <School className="h-5 w-5 text-primary mt-1" />
                <span className="text-muted-foreground">{school}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {neighborhoodStats.amenities?.length > 0 && (
        <div className="mt-6">
          <h3 className="font-medium mb-3">Local Amenities</h3>
          <ul className="space-y-3">
            {neighborhoodStats.amenities.map((amenity, index) => (
              <li key={index} className="flex items-start space-x-3">
                <Building className="h-5 w-5 text-primary mt-1" />
                <span className="text-muted-foreground">{amenity}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </Card>
  );
};